import Vue from 'vue'
import store from '@/store'

const addParam = (url, key, value) => {
  return !['-1', 'null', null].includes(value)
    ? url
      ? `${url}&${key}=${value}`
      : `?${key}=${value}`
    : url
}

const addParams = (url, params) => {
  const keys = Object.keys(params)
  if (keys.length) {
    const key = keys[0]
    const { [key]: value, ...restParams } = params
    const urlWithParam = Array.isArray(value)
      ? addParam(url, key, value.join(','))
      : addParam(url, key, value)
    return addParams(urlWithParam, restParams)
  }
  return url
}

export function addQueryParams (url, params) {
  return `${url}${addParams('', params)}`
}

export const formateDateString = (date) => `${date.substring(0, 10)}`

export const formateDate = (date) => {
  if (date !== null) {
    const day = date.getDate()
    const month = date.getMonth() + 1
    const year = date.getFullYear()
    const daystr = day < 10 ? `0${day}` : day
    const monthstr = month < 10 ? `0${month}` : month
    return `${year}-${monthstr}-${daystr}`
  }
  return date
}

export function subtractDaysFromDate (date, days) {
  const resultDate = new Date(date)
  resultDate.setDate(resultDate.getDate() - days)
  return resultDate
}

export const formateDateReverse = (date) => {
  return formateDate(date).split('-').reverse().join('-')
}

export const formateDateText = (date) => {
  if (date !== null) {
    // console.log(Vue.i18n.translate('date.days.sunday'))
    const DAYS = [
      Vue.i18n.translate('date.days.sunday'),
      Vue.i18n.translate('date.days.monday'),
      Vue.i18n.translate('date.days.tuesday'),
      Vue.i18n.translate('date.days.wednesday'),
      Vue.i18n.translate('date.days.thursday'),
      Vue.i18n.translate('date.days.friday'),
      Vue.i18n.translate('date.days.saturday')
    ]

    const MONTHS = [
      Vue.i18n.translate('date.months.january'),
      Vue.i18n.translate('date.months.february'),
      Vue.i18n.translate('date.months.march'),
      Vue.i18n.translate('date.months.april'),
      Vue.i18n.translate('date.months.may'),
      Vue.i18n.translate('date.months.june'),
      Vue.i18n.translate('date.months.july'),
      Vue.i18n.translate('date.months.august'),
      Vue.i18n.translate('date.months.september'),
      Vue.i18n.translate('date.months.october'),
      Vue.i18n.translate('date.months.november'),
      Vue.i18n.translate('date.months.december')
    ]

    const dayOfMonth = MONTHS[date.getMonth()]
    const dayOfWeek = DAYS[date.getDay()]
    const day = date.getDate()
    const year = date.getFullYear()
    const daystr = day < 10 ? `0${day}` : day
    return `${dayOfWeek} ${daystr} ${dayOfMonth} ${year}`
  }
  return date
}

export function dateTimeString (date) {
  let str = dateTimeLocalString(date)
  if (str) {
    let d = str.substring(0, 10)
    let t = str.substring(11, 17)
    return d + ' / ' + t
  }
  return '-'
}

export function dateString (date) {
  let str = dateTimeLocalString(date)
  if (str) {
    let d = str.substring(0, 10)
    return d
  }
  return '-'
}

export function timeString (date) {
  let str = dateTimeLocalString(date)
  if (str) {
    let t = str.substring(11, 17)
    return t
  }
  return '-'
}

export function liststr (value, field = 'name') {
  let result = ''
  for (const item of value) {
    result += `${item[field]}, `
  }
  return result.substring(0, result.length - 2)
}

export function dateTimeLocalString (date) {
  if (date) {
    const timezone = store.getters.timezone
    return new Date(date).toLocaleString('uk-UA', { timeZone: timezone })
  }
  return null
}

export function round (value) {
  return Math.floor((Math.floor(value * 1000) / 10)) / 100
}
